export default "__VITE_ASSET__cb70a853__"